/* Para novos eventos, utilizar a nova taxonomia de eventos -> datahubDefaultEvent.enums.ts */
export enum System {
  MEMBERSHIP_COMMUNITY = 'mem_community_consume',
  DH_MEMBERSHIP_COMMUNITY = 'dh_mem_community_consume'
}

export enum Actions {
  BAN = 'ban',
  BLOCK = 'block',
  CREATE = 'create',
  DELETE = 'delete',
  OPEN = 'open',
  POST = 'post',
  SAVE = 'save',
  SCHEDULE = 'schedule',
  SETUP = 'setup',
  VIEW = 'view',
  ONBOARDING = 'onboarding',
  ANSWER = 'answer',
  FOLLOW = 'follow'
}

export enum Event {
  COMMUNITY = 'community'
}

export enum Entities {
  BAN = 'ban',
  COMMUNITY = 'community',
  COMMUNITY_USER = 'community:user',
  COMMUNITY_VIEW = 'community_view',
  GENERIC = 'generic_ui_action',
  SCHEDULED_POST = 'scheduled_post',
  SURVEY_COMMUNITY_CREATE = 'survey_community_create',
  SURVEY_COMMUNITY_BIND = 'survey_community_bind',
  SURVEY_FIRST_POST = 'survey_first_post',
  SURVEY_SECOND_POST = 'survey_second_post'
}

export enum Platform {
  WEB = 'WEB'
}

export enum ScreenNames {
  BAN_MODAL = 'ban_modal',
  COMMUNITY_EDIT_VIEW = 'CommunityEditView',
  COMMUNITY_FEED = 'community-feed',
  COMMUNITY_FEED_NO_ACCESS = 'community-feed/no-access',
  COMMUNITY_VIEW = 'CommunityView',
  CREATE_COMMUNITY_VIEW = 'CommunityCreateView',
  EMPTY_STATE_PAYWALL = 'community-feed/paywall',
  EMPTY_STATE_PROCESSING_ACCESS = 'community-feed/processing-access',
  FILTER_SCHEDULED_LIST = 'filter_scheduled_list',
  EMPTY_STATE_UNDER_CONSTRUCTION = 'community-feed/under-construction',
  HOME_COMMUNITY = 'home_community',
  POST_ACTIONS = 'scheduled_actions',
  SCHEDULED_ACTIONS = 'scheduled_actions',
  COMMUNITY_POST_DETAIL_PAYWALL = 'community-post-detail/paywall',
  COMMUNITY_POST_DETAIL = 'community-post-detail',
  COMMUNITY_POST_COMMENT = 'community-post-comment',
  ONBOARDING = 'onboarding',
  ONBOARDING_MODAL_IA = 'onboarding-modal-ia',
  COMMUNITY_NO_SEARCH_RESULTS = 'community_no_search_results',
  COMMUNITY_COLLABORATIVE_POST = 'community-collaborative-post',
  NORMAL_POST = 'NORMAL-POST',
  HOME_CLUB = 'HOME-CLUB',
  RANKING = 'RANKING',
  COMMUNITY_NEW_FEED = 'COMMUNITY_NEW_FEED',
  COMMUNITY_POST_LIST = 'COMMUNITY_POST_LIST',
  COMMUNITY_POST = 'COMMUNITY_POST'
}

export enum ComponentSources {
  COMMUNITY_HEADER = 'COMMUNITY-HEADER',
  COMMUNITY_BANNER = 'COMMUNITY-BANNER',
  POST_FIELD = 'POST-FIELD',
  REACTION_BAR = 'REACTION-BAR',
  LIKE_BUTTON = 'LIKE-BUTTON'
}

export enum ComponentNames {
  ALL_PRODUCTS_MODAL = 'ALL-PRODUCTS-MODAL-MODAL',
  BUTTON_BIND_COURSES = 'BUTTON_BIND_COURSES',
  COMMUNITY_FEED = 'COMMUNITY-FEED',
  COMMUNITY_INFO_MODAL = 'COMMUNITY-INFO-MODAL',
  FILTER_BUTTON = 'FILTER-BUTTON',
  TOP_DROPDOWN = 'TOP-DROPDOWN',
  INPUT_POST = 'INPUT-POST',
  INPUT_COMMENT = 'INPUT-COMMENT',
  COMMENT_ITEM = 'COMMENT-ITEM',
  PIN_POST_SIDEBAR = 'PIN-POST-SIDEBAR',
  ONBOARDING = 'ONBOARDING',
  ONBOARDING_ROLE_ITEM = 'ONBOARDING-ROLE-ITEM',
  ONBOARDING_RULES_POST_ITEM = 'ONBOARDING-RULES-POST-ITEM',
  ONBOARDING_COPY_ITEM = 'ONBOARDING-COPY-ITEM',
  ONBOARDING_ICON = 'ONBOARDING-ICON',
  ONBOARDING_CLOSE = 'ONBOARDING-CLOSE',
  ONBOARDING_NAME_ITEM = 'ONBOARDING-NAME-ITEM',
  ONBOARDING_COVER_ITEM = 'ONBOARDING-COVER-ITEM',
  ONBOARDING_GROUP_ITEM = 'ONBOARDING-GROUP-ITEM',
  ONBOARDING_SCHEDULE_ITEM = 'ONBOARDING-SCHEDULE-ITEM',
  ONBOARDING_WELCOME_POST_ITEM = 'ONBOARDING-WELCOME-POST-ITEM',
  ONBOARDING_INCENTIVE_POST_ITEM = 'ONBOARDING-INCENTIVE-POST-ITEM',
  ONBOARDING_LIKE_THE_COPY = 'ONBOOARDING_LIKE_THE_COPY',
  ONBOARDING_DISLIKE_THE_COPY = 'ONBOOARDING_DISLIKE_THE_COPY',
  FINISHED_CLASS = 'FINISHED-CLASS',
  FINISHED_CLASS_CTA = 'FINISHED-CLASS-CTA',
  STAR_RATING = 'STAR-RATING',
  NO_SEARCH_RESULTS = 'NoSearchResults',
  COMMUNITY_NOTIFICATION = 'COMMUNITY-NOTIFICATION',
  AI_POST_SURVEY = 'AI-POST-SURVEY',
  HOME_CLUB = 'HOME-CLUB',
  FEATURED_MEMBERS = 'FEATURED_MEMBERS',
  NEW_FEED = 'NEW-FEED',
  NEW_FEED_CARD = 'NEW-FEED-CARD',
  COMMUNITY_REACTIONS = 'COMMUNITY-REACTIONS',
  BE_MEMBER_HEADER_BUTTON = 'BE-MEMBER-HEADER-BUTTON',
  BE_MEMBER_BANNER_BUTTON = 'BE-MEMBER-BANNER-BUTTON',
  FLOATING_BUTTON = 'FLOATING_BUTTON',
  MAIN_CTA = 'MAIN_CTA'
}

export enum EventNames {
  CLICK_TO_BUY_A_PRODUCT = 'click to buy a product',
  CLICK_TO_GO_TO_SCHEDULED_POSTS = 'click to go to scheduled posts',
  CLICK_TO_SEE_ALL_PRODUCTS_PAY_WALL = 'click to see all products',
  CLICK_TO_VIEW_COMMUNITY_INFO = 'click to view community info',
  CLICK_USER_PROFILE_MEMBERS_RANKING = 'click_user_profile_members_ranking',
  SETUP_COMMUNITY = 'click to setup community',
  TRY_TO_BLOCK_A_USER = 'try to block a user',
  TRY_TO_DELETE_A_POST = 'try to delete a post',
  TRY_TO_DELETE_SCHEDULE_POST = 'try to delete schedule a post',
  TRY_TO_PIN_A_POST = 'try to pin a post',
  TRY_TO_UNPIN_A_POST = 'try to unpin a post',
  TRY_TO_POST_A_SCHEDULED_POST = 'try to post a scheduled post',
  TRY_TO_SCHEDULE_A_POST = 'try to schedule a post',
  TRY_TO_POST = 'try to post',
  VIEW_COMMUNITY_FEED = 'view community feed',
  VIEW_POST_DETAIL = 'view post detail',
  CLICK_TO_GO_TO_POST_DETAIL = 'click to go to post detail',
  CLICK_SUGGESTED_COMMENT = 'click suggested comment',
  CLICK_TO_START_A_COMMENT = 'click to start a comment',
  TRY_TO_POST_A_COMMENT = 'try to post a comment',
  CLICK_TO_GO_TO_PIN_LIST = 'click to go to pin list',
  CLICK_TO_UPLOAD_IMAGE_ON_COMMENT = 'click to upload image on comment',
  CLICK_TO_VIEW_A_IMAGE_ON_COMMENT = 'click to view image on comment',
  CLICK_TO_REPLY_TO_COMMENT = 'click to reply to comment',
  CLICK_TO_UPLOAD_PDF_ON_COMMENT = 'click to upload pdf on comment',
  CLICK_TO_CHOOSE_ROLE = 'click to choose a moderator',
  CLICK_TO_CREATE_POST = 'click to create a post',
  CLICK_TO_COPY_LINK = 'click to copy a link',
  CLICK_TO_OPEN_ONBOARDING = 'click to open onboarding',
  CLICK_TO_CLOSE_ONBOARDING = 'click to close onboarding',
  CLICK_TO_NAME_A_COMMUNITY = 'click to name a community',
  CLICK_TO_ADD_A_COVER = 'click to add a cover',
  CLICK_TO_CREATE_A_GROUP = 'click to create a group',
  CLICK_TO_CHOOSE_A_MODERATOR = 'click to choose a moderator',
  CLICK_TO_LIKE_THE_COPY = 'click to like the copy',
  CLICK_TO_DISLIKE_THE_COPY = 'click to dislike the copy',
  CLICK_TO_SCHEDULE_POST = 'click to scheduled a post',
  CLICK_TO_APP_STORE = 'click to go to app store',
  CLICK_TO_START_AUDIO_RECORDING = 'click to start audio recording',
  CLICK_TO_COPY_TEXT = 'click to copy text',
  CLICK_TO_REMAKE_TEXT = 'click to remake text',
  VIEW_TO_EMPTY_STATE_ON_SEARCH = 'view to empty state on search',
  CLICK_TO_LOAD_MORE_COMMUNITIES_ON_SEARCH = 'click to load more communities on search',
  CLICK_TO_CREATE_A_POST_ON_SEARCH = 'click to create a post on search',
  CLICK_TO_RATE_OR_FINISH_A_CLASS = 'click to rate or finish a class',
  CLICK_TO_START_A_POST = 'click to start a post',
  CLICK_TO_SEE_COMMUNITY_NOTIFICATION = 'click to see community notification',
  CLICK_TO_ANSWER_A_SURVEY = 'click to answer a survey',
  TRY_TO_UPLOAD_PDF_ATTACHMENT_ABOVE_THE_SIZE_LIMIT = 'try to upload pdf attachment above the size limit',
  VIEW_TRENDING_POST_LIST_HOME = 'view trending post list home',
  CLICK_TO_SELECT_COMMUNITY_FILTER_MY_POSTS = 'click to select community filter my posts',
  CLICK_TO_COMMUNITY_HOME_LIST = 'click to community home list',
  CLICK_TO_ACCESS_FEATURED_MEMBERS = 'click to access featured members',
  VIEW_EMPTY_STATE_FEATURED_MEMBERS = 'view empty state featured members',
  CLICK_TO_USER_PROFILE_MEMBERS_RANKING = 'click to user profile members ranking',
  CLICK_TO_SHOW_MORE_POSTS = 'click to show more posts',
  COMMUNITY_CREATION_SATISFACTION_SURVEY = 'community creation satisfaction survey',
  COMMUNITY_FIRST_POST_SATISFACTION_SURVEY = 'community first post satisfaction survey',
  COMMUNITY_SECOND_POST_SATISFACTION_SURVEY = 'community second post satisfaction survey',
  BIND_EXCLUSIVE_COMMUNITY_SURVEY = 'bind exclusive community survey',
  CLICK_TO_LOAD_FEED = 'click to load feed',
  VIEW_FEED_EMPTY_STATE = 'view feed empty state',
  TRY_TO_FOLLOW_COMMUNITY = 'try to follow community',
  TRY_TO_UNFOLLOW_COMMUNITY = 'try to unfollow community',
  CLICK_TO_FOLLOW_COMMUNITY = 'click to follow community',
  VIEW_POST_PREVIEW = 'view post preview',
  CLICK_TO_SEE_MORE_POST_DETAIL = 'click to see more post detail',
  TRY_TO_REACT_TO_A_POST = 'try to react to a post'
}

export enum SurveyNames {
  FIRST_COMMUNITY = 'Primeira comunidade',
  FIRST_POST = 'Primeira postagem',
  SECOND_POST = 'Segunda postagem',
  BIND_EXCLUSIVE_COMMUNITY = 'Vinculação de Comunidade Exclusiva'
}

export enum ResultsTypes {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE'
}

export type ResultType = `${ResultsTypes}`

export enum ArrivedFrom {
  FEED = 'FEED',
  HOME = 'HOME',
  COMMUNITY_NEW_FEED = 'COMMUNITY_NEW_FEED',
  CLASSROOM = 'CLASSROOM',
  COMMUNITY_POST_LIST = 'COMMUNITY_POST_LIST',
  COMMUNITY_EMPTY_STATE = 'COMMUNITY_EMPTY_STATE'
}
